
import './App.css';
import Annotation from './components/Annotation';
import Body from './components/Body';
import Footer from './components/Footer';
import {BsFillArrowUpCircleFill} from 'react-icons/bs'
import {useEffect, useState} from 'react'
function App() {
  const [disp,setDisp]=useState({display:"none"})
  const [scrollTop,setScroll]=useState(0);
  const scroller=()=>{
    let scroll = window.scrollY;
    setScroll(scroll);
    if(scrollTop>=150){
      setDisp({display:"block"})
    }else{
      setDisp({display:"none"})
    }
  }
  useEffect(() => {
   window.addEventListener('scroll',scroller)
   
   console.log(scrollTop);
   // eslint-disable-next-line 
  }, [scrollTop]);
  const gotoTop=()=>{
    window.scrollTo(0,-10);
  }
  return (
    <div className="App" >
      <Annotation />  
      <Body/>   
      <div onClick={gotoTop}  id="return-to-top" style={disp}><BsFillArrowUpCircleFill/></div>
      <Footer/>
    </div>
  );
}

export default App;
